// Shared LP behaviors. All guarded (querySelector/getElementById null-safe) so a
// section that isn't present just no-ops. No chrome JS (Horizon owns nav/cart).
(function () {
  // Idempotent boot: sections each include this script, so it may execute N times.
  // Guard so listeners bind exactly once. (Editor drag-in needs a reload to gain JS.)
  if (window.__lpBooted) { return; }
  window.__lpBooted = true;
  var BODY_SEL = '.acc-body,.rf-body,.faq-body';
  function setOpen(item, head, open) {
    var body = item.querySelector(BODY_SEL); if (!body) return;
    if (open) { item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
    else { item.classList.remove('open'); body.style.maxHeight = null; }
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function initAcc(id, headSel, itemSel) {
    var root = document.getElementById(id); if (!root) return;
    root.querySelectorAll(headSel).forEach(function (h) {
      var item = h.closest(itemSel);
      h.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      h.addEventListener('click', function () { setOpen(item, h, !item.classList.contains('open')); });
    });
    root.querySelectorAll(itemSel + '.open').forEach(function (item) { setOpen(item, item.querySelector(headSel), true); });
  }
  initAcc('heroAcc', '.acc-head', '.acc-item');
  initAcc('oneAcc', '.acc-head', '.acc-item');
  initAcc('rfAcc', '.rf-head', '.rf-item');
  initAcc('faq', '.faq-head', '.faq-item');

  function recalcOpen() {
    document.querySelectorAll('.acc-item.open,.rf-item.open,.faq-item.open').forEach(function (item) {
      var body = item.querySelector(BODY_SEL); if (body) body.style.maxHeight = body.scrollHeight + 'px';
    });
  }
  window.addEventListener('load', recalcOpen);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(recalcOpen);
  var rT; window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(recalcOpen, 120); });

  // gallery: thumbnails <-> swipeable main (scroll-snap carousel)
  (function () {
    var main = document.getElementById('galleryMain');
    if (!main) return;
    var thumbs = [].slice.call(document.querySelectorAll('.thumbs img'));
    var slides = [].slice.call(main.querySelectorAll('img'));
    function setActive(i) {
      thumbs.forEach(function (t) { t.classList.toggle('active', +t.getAttribute('data-index') === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-index');
        main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(+e.target.getAttribute('data-index')); });
      }, { root: main, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      var st;
      main.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { setActive(Math.round(main.scrollLeft / main.clientWidth)); }, 80);
      });
    }
  })();

  // bundle radios -> visual select + set variant on the product form
  document.querySelectorAll('.bundle input[name="bundle"]').forEach(function (r) {
    r.addEventListener('change', function () {
      document.querySelectorAll('.bundle').forEach(function (x) { x.classList.remove('sel'); });
      r.closest('.bundle').classList.add('sel');
      var vid = r.getAttribute('data-variant');
      var idInput = document.querySelector('.lp-atc-form input[name="id"]');
      if (vid && idInput) idInput.value = vid;
      var qty = r.getAttribute('data-qty');
      var qtyInput = document.querySelector('.lp-atc-form input[name="quantity"]');
      if (qty && qtyInput) qtyInput.value = qty;
    });
  });

  // before/after tabs (later section)
  var tabs = document.querySelectorAll('#baTabs .tab');
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
      t.classList.add('active'); t.setAttribute('aria-selected', 'true');
      document.querySelectorAll('.ba-panel').forEach(function (p) { p.classList.remove('active'); });
      var panel = document.getElementById('ba-' + i); if (panel) panel.classList.add('active');
    });
  });
})();
